// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Button,

  Icon,
  Input,
  useDisclosure,
  Modal,
  ModalOverlay,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Grid,
  FormHelperText,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useColorMode,
  useColorModeValue
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import NiceButton from "components/NiceButton/NiceButton.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import TourTable from "components/Tables/TourTable";
import React, { useEffect, useState, useMemo } from "react";
import tourData from "variables/tours";
import { ToastContainer, toast } from 'react-toastify';
var moment = require('moment-jalaali')
import IconBox from "components/Icons/IconBox";
import { RiPlantLine } from "react-icons/ri";
import verify from "api/payment/verify";
import { useHistory, useLocation } from "react-router-dom";
import me from "api/authenticate/me";
import { setGlobal } from "config/global";

function CallBack() {
  const history = useHistory();
  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  console.log()

  const { colorMode } = useColorMode();
  const iconBlue = useColorModeValue("gray.100", "navy.700");
  const [isCreateTourLoading, setIsCreateTourLoading] = useState(false);
  const textColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const [isLoading, setIsLoading] = useState(false);
  const [tablesTableData, setTablesTableData] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [reload, setReload] = useState(false);
  const [title, setTitle] = useState("");
  const [address, setAddress] = useState("");

  useEffect(() => {
    setIsLoading(true)
    let Authority = searchParams.get("Authority")
    let Status = searchParams.get("Status")
    if (Status == "OK") {
      verify(Authority).then((result) => {
        me().then((data)=>{
          setGlobal({me:data?.data});
        })
        return toast.success("پرداخت موفق", {
          position: "bottom-right"
        })
      }).catch((err) => {
        console.error(err)
        if (err?.response?.data?.message?.pr)
          return toast.error(err?.response?.data?.message?.pr, {
            position: "bottom-right"
          })
        else
          return toast.error("پرداخت ناموفق بود، در صورت کسر وجه ظرف 72 ساعت به حساب شما باز می‌گردد.", {
            position: "bottom-right"
          })
      }).finally(() => {
        history.push("/admin/dashboard")
        setIsLoading(false)
      })
    } else {
      history.push("/admin/dashboard")
      return toast.error("پرداخت ناموفق بود، در صورت کسر وجه ظرف 72 ساعت به حساب شما باز می‌گردد.", {
        position: "bottom-right"
      })
    }
  }, [])

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardHeader>
          <Flex justify='space-between' align='center' mb='1rem' w='100%'>
            <Text fontSize='md' color={textColor} fontWeight='bold'>
              برگشت از بانک
            </Text>

          </Flex>
        </CardHeader>
        <CardBody>
        </CardBody>
      </Card>
    </Flex>
  );
}

export default CallBack;
